var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyndlykill = function SvgMyndlykill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#myndlykill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.667 88h-40a8.026 8.026 0 0 1-8-8V10.666a8 8 0 0 1 8-8h106.666a8 8 0 0 1 8 8V80a8.026 8.026 0 0 1-8 8h-8",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.334 70.5H70.666a6.833 6.833 0 0 0-6.834 6.833V120a6.833 6.833 0 0 0 6.834 6.833h18.666A6.833 6.833 0 0 0 96.168 120V77.333a6.833 6.833 0 0 0-6.834-6.833Z",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.462 39.77a34.668 34.668 0 0 0-34.923-.752M92.09 48.853a24 24 0 0 0-24.18-.533M86.699 57.962a13.286 13.286 0 0 0-13.397-.266",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 88,
    r: 3,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "myndlykill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v128H0z"
  })))));
};
export default SvgMyndlykill;